export default {
  heading: "Dimbo, system-ui, semi-bold",
  body: "Inter, system-ui",
  text: "Dimbo, Inter, DM Sans",
};
